import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

function Copyright() {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      sx={{ my: 4 }}
    >
      {"Built with 💗 by eculeus. Copyright © "}
      {new Date().getFullYear()}
      {". Contact/Bug Reports: "}
      <Link color="inherit" href="mailto:hello@loopandlearn.app">
        hello@loopandlearn.app
      </Link>
    </Typography>
  );
}

export default Copyright;
